import React, { useState } from "react";
import { Button, Input, Card, message } from "antd";

const API_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

interface AdminLoginResponse {
  token?: string;
  error?: string;
  status?: string;
}

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      let data: AdminLoginResponse = {};
      try {
        data = await res.json();
      } catch {}

      if (res.ok && data.token) {
        localStorage.setItem("admin_token", data.token);
        window.location.href = "/product-create";
      } else {
        message.error(data.error || "Ошибка входа");
      }
    } catch {
      message.error("Ошибка входа");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Card title="Вход в админку" style={{ width: 340 }}>
        <form onSubmit={handleLogin}>
          <Input
            placeholder="Логин"
            value={username}
            onChange={e => setUsername(e.target.value)}
            style={{ marginBottom: 16 }}
          />
          <Input.Password
            placeholder="Пароль"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ marginBottom: 16 }}
          />
          <Button htmlType="submit" type="primary" block loading={loading}>
            Войти
          </Button>
        </form>
      </Card>
    </div>
  );
}
